module.exports = __webpack_public_path__ + "static/media/Sec-4-Background_Mobile.181e10e2.jpg";